document.addEventListener('DOMContentLoaded', function() {
  var imgs = document.querySelectorAll('.header__heading-logo-wrapper img');
  imgs.forEach(function(img) {
    var v = document.createElement('video');
    v.autoplay = true;
    v.loop = true;
    v.muted = true;
    v.setAttribute('playsinline', '');
    v.className = img.className;
    v.style.display = 'block';
    v.style.width = img.getAttribute('width') ? img.getAttribute('width') + 'px' : 'auto';
    v.style.height = 'auto';
    var s = document.createElement('source');
    s.src = 'https://cdn.shopify.com/videos/c/o/v/b8d8b66c1ac6492f9392787549e77d6e.webm';
    s.type = 'video/webm';
    v.appendChild(s);
    img.parentNode.replaceChild(v, img);
  });
});
